import { useDebounceValue } from '@exodus/react-hooks';
import { useMemo } from 'react';
import { useQuoteContext } from '../context/quote.js';
import { useValidationContext } from '../context/validation.js';
import useFromAmount from './use-from-amount.js';
const useCanExchange = () => {
    const quote = useQuoteContext();
    const [fromAmount] = useFromAmount();
    const { preventFromExchanging } = useValidationContext();
    const show = useMemo(() => !!quote.value && fromAmount.isPositive && !preventFromExchanging, [fromAmount.isPositive, preventFromExchanging, quote.value]);
    return useDebounceValue(show, 100);
};
export default useCanExchange;
